var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import GoogleMapReact from 'google-map-react';
import { Pin } from './Pin';
import './Maps.css';
export var MapItem = function (_a) {
    var children = _a.children;
    return React.createElement(React.Fragment, null, children);
};
var getProps = function (customStyles, showZoomControls) {
    var defaultStyles = [
        {
            // disables poi
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
        },
    ];
    var options = {
        overviewMapControl: true,
        streetViewControl: false,
        rotateControl: true,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControl: showZoomControls,
        styles: customStyles || defaultStyles,
    };
    return {
        defaultCenter: { lat: 42.69, lng: 23.32 },
        defaultZoom: 18,
        defaultOptions: options,
        options: options,
    };
};
var coord2loc = function (c) { return ({ latitude: c.lat, longitude: c.lng }); };
var loc2coord = function (l) { return ({ lat: l.latitude, lng: l.longitude }); };
export var Maps = function (_a) {
    var children = _a.children, center = _a.center, zoom = _a.zoom, defaultCenter = _a.defaultCenter, defaultZoom = _a.defaultZoom, _b = _a.centerPin, centerPin = _b === void 0 ? React.createElement(Pin, null) : _b, styles = _a.styles, showZoomControls = _a.showZoomControls, mapApiKey = _a.mapApiKey, onChange = _a.onChange;
    var _c = useMemo(function () { return ({
        centerCoords: center ? loc2coord(center) : undefined,
        defaultCenterCoords: defaultCenter ? loc2coord(defaultCenter) : undefined,
    }); }, [center, defaultCenter]), centerCoords = _c.centerCoords, defaultCenterCoords = _c.defaultCenterCoords;
    var props = useMemo(function () { return getProps(styles, showZoomControls); }, [
        styles,
        showZoomControls,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "center-pin" }, centerPin),
        React.createElement(GoogleMapReact, __assign({}, props, { bootstrapURLKeys: { key: mapApiKey || '' }, center: centerCoords, zoom: zoom, defaultCenter: defaultCenterCoords || props.defaultCenter, defaultZoom: defaultZoom || props.defaultZoom, onChange: function (props) {
                var center = props.center, _a = props.bounds, sw = _a.sw, ne = _a.ne, zoom = props.zoom;
                console.debug('GoogleMaps onChange', props);
                onChange === null || onChange === void 0 ? void 0 : onChange(coord2loc(center), { minLat: sw.lat, maxLat: ne.lat, minLng: sw.lng, maxLng: ne.lng }, zoom);
            } }), children)));
};
//# sourceMappingURL=Maps.js.map